module.exports = __webpack_public_path__ + "static/media/earnedInADay_250000_500000.38aa1aff.png";